<template>
  <div>
    <div class="form-container ou-donation-form teach-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit/>
            </div>
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>   
            <FormRow>
            <FormLabel class="control-label"> Spouse's Name </FormLabel>
          </FormRow>
          <FormRow >
            <FormInput
              type="text"
              class="width-full"
              field="custom.spouseName"
            />
          </FormRow>   
          <FormRow inline>
            <input
          id="amount__single"
          type="checkbox"
          class="amount"
          :checked="getValue('custom.stayingAtHotel')"
          @click="setValue('custom.stayingAtHotel', !getValue('custom.stayingAtHotel'))"
        />
        <FormLabel for="amount__single">
           <span class="label-description">I will be staying at the hotel</span>
        </FormLabel>
          </FormRow>  
          <FormRow inline>
              <FormCol field="custom.schoolName" width="half" :showLabel="false">
                <FormLabel class="control-label"> School Affiliation: </FormLabel>
                <FormInput
              type="text"
              class="width-full"
              field="custom.schoolName"
                />
              </FormCol>
            </FormRow>                   
            </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <div class="payment-info">
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" class="teachpay" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { usePaymentForm } from '~/shared/use-payment-form';

export default defineComponent({
    setup () {
        const { getValue, setValue } = usePaymentForm()

        return {
            getValue,
            setValue
        }
    }
})
</script>